import { render, staticRenderFns } from "./GuestPasses.vue?vue&type=template&id=56ea2a09&"
import script from "./GuestPasses.vue?vue&type=script&lang=ts&"
export * from "./GuestPasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports